<template>
	<div class="input-group d-flex align-items-baseline is-size-6 py-1 px-1" role="row">
		<!-- important that the key events are KEYUP - refer to CheckGroup.vue for more information -->
		<!-- unsure how to make this tooltip accessible via ARIA, official guidelines are still a work in progress as of January 2019 https://www.w3.org/TR/wai-aria-practices-1.1/#tooltip -->
		<span
			class="icon is-small has-text-info d-none d-widescreen-inline-block pr-4 focus-outline-yellow"
			@keyup.enter="showTooltip" @keyup.27="hideTooltip"
			@mouseover="showTooltip" @mouseleave="hideTooltip"
			tabindex="0">
				<i class="fas fa-info-circle"></i>
		</span>
		<label class="d-flex align-items-center justify-content-between" role="gridcell" :aria-label="name">
			{{ name }}
			<input class="focus-outline-yellow" type="checkbox" :checked="selected" @change="toggle">
		</label>
	</div>
</template>

<script>
	import { $window } from '@/windowDimensions.js'

	export default {
		props: ['id', 'name', 'description'],
		computed: {
			windowWidth() { return $window.width },
			selected() { return this.$store.state.search.filters.features[this.name] },
			tooltip: {
				get() { return this.$store.state.main.tooltip },
				set(value) { this.$store.commit('updateTooltip', value) }
			}
		},
		methods: {
			toggle(e) {
				this.$store.commit('toggleFeature', { name: this.name, checked: e.target.checked })
				this.$store.dispatch('basicSearch')

				// scroll up on smaller screens when filters is fixed on screen
				if (this.windowWidth < 1216) {
					document.documentElement.scrollIntoView()
				}

				// Analytics tracking
				if (e.target.checked) {
					gtag('event', 'feature_selected', {
						'event_category': 'sidebar_interaction',
						'event_label': e.target.id
					})
				}
			},
			showTooltip() {
				this.tooltip = { display: true, id: this.id, title: this.name, description: this.description }
			},
			hideTooltip() {
				this.tooltip = { display: false, id: this.id, title: this.name, description: this.description }
			}
		}
	}
</script>

<style lang="scss" scoped>
	.input-group {
		color: #fff;
		text-align: left;
		span.name {
			flex-shrink: 5;
		}
		label {
			flex-grow: 1;
		}
	}
	.input-group:hover {
		cursor: pointer;
		background-color: #7c6493;
	}
	label:hover, input:hover {
		cursor: pointer;
	}
</style>
